import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "./pages/HomePage";
import { ROUTES } from "./utils/Routes";
import PageLayout from "./layout/PageLayout";
import AboutUsPage from "./pages/AboutUsPage";
import ServicesPage from "./pages/ServicesPage";
import ContactUsPage from "./pages/ContactUsPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";

const router = createBrowserRouter([
    {
        element: <PageLayout />,
        children: [
            {
                path: ROUTES.HOMEPAGE_ROUTE,
                element: <HomePage />,
            }, 
            {
                path:`${ROUTES.ABOUTUS_ROUTE}`,
                element: <AboutUsPage />
            },
            {
                path:`${ROUTES.SERVICE_ROUTE}/:serviceType`,
                element: <ServicesPage />
            },
            {
                path:`${ROUTES.CONTACTUS_ROUTE}`,
                element: <ContactUsPage />
            },
            {
                path:`${ROUTES.TERMS_CONDITIONS_ROUTE}`,
                element: <TermsPage />
            },
            {
                path:`${ROUTES.PRIVACY_POLICY_ROUTE}`,
                element: <PrivacyPage />
            },
        ]
    }
])

export default function RouteComponent() {
    return <RouterProvider router={router} />;
}